(() => {
  function mount() {
    document.querySelectorAll('[data-magnet-product]').forEach(root => {
      if (root.dataset.ready || !window.SouvenirMagnets) return;
      root.dataset.ready = 'true';
      const api = window.SouvenirMagnets, quantity = root.querySelector('[data-magnet-quantity]');
      const buttons = [...root.querySelectorAll('[data-product-add],[data-product-buy]')];
      const message = root.querySelector('[data-product-message]');
      quantity.addEventListener('change', () => {root.querySelector('[data-selection-price]').textContent = api.money(api.total(Number(quantity.value)));});
      buttons.forEach(button => {
        button.disabled = false;
        button.addEventListener('click', async () => {
          buttons.forEach(b => b.disabled = true); quantity.disabled = true; message.textContent = 'Adding your magnets and applying savings…';
          try {
            await api.add(Array(Number(quantity.value)).fill(root.dataset.designId));
            message.textContent = 'Added! Your cart combines all magnet designs for the best quantity price.';
            if (button.hasAttribute('data-product-buy')) await api.checkout();
          } catch (error) {message.textContent = error.message;}
          finally {buttons.forEach(b => b.disabled = false); quantity.disabled = false;}
        });
      });
    });
  }
  mount(); window.addEventListener('souvenir:commerce-ready',mount); document.addEventListener('shopify:section:load',mount);
})();
